import { environment } from '@/utils/env.utils';

/** Page-view event name expected by the GTM container */
export const GTM_PAGE_EVENT = 'Loaded a Page';

const GTM_SCRIPT_ID = 'fairlo-gtm-script';

const ensureDataLayer = (): NonNullable<Window['dataLayer']> => {
  window.dataLayer = window.dataLayer ?? [];
  return window.dataLayer;
};

/** Injects the GTM container snippet. No-ops if this module already injected it. */
export const initializeGtm = (): void => {
  if (document.getElementById(GTM_SCRIPT_ID)) {
    return;
  }

  const dataLayer = ensureDataLayer();
  dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${environment.gtmContainerId}`;
  document.head.appendChild(script);
};

export const trackGtmEvent = (event: string, props?: Record<string, unknown>): void => {
  ensureDataLayer().push({
    ...props,
    event,
  });
};
